import { Box } from "@mui/material";
import { Logo, colors } from "brand";

// Shared Fox Village-branded page frame — logo header + centered content
// column. Used by every public page in this app (landing, sheets list, and
// the #971 /open interstitial) so a rider sees the same branded chrome no
// matter which state a page is in, including error/loading states.
export default function PageShell({ children }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: 3,
      }}
    >
      <Box sx={{ color: colors.foxOrange, width: 200, mb: 3 }}>
        <Logo style={{ width: "100%", height: "auto", display: "block" }} />
      </Box>
      <Box sx={{ width: "100%", maxWidth: 720 }}>{children}</Box>
    </Box>
  );
}
